import { Form } from "@circle-react-uikit/Form";
import type { SpaceType } from "@circle-react/types/Space";

import { t } from "@/i18n-js/instance";

import { shouldRenderEventAutoRsvp } from "../../utils/notificationVisibility";

interface EventAutoRsvpFieldProps {
  postType: SpaceType;
}

export const EventAutoRsvpField = ({ postType }: EventAutoRsvpFieldProps) => {
  if (!shouldRenderEventAutoRsvp(postType)) {
    return null;
  }
  return (
    <Form.Item
      name="event_auto_rsvp_enabled"
      label={t("spaces.form.event_auto_rsvp_enabled")}
      hideBorder
      hideDescription
      inline
      shouldToggleValueOnLabelClick
    >
      <Form.ToggleSwitch name="event_auto_rsvp_enabled" variant="small" />
    </Form.Item>
  );
};
